export async function fetchBlog(slug) {
    let r = await fetch(`/api/blog/${slug}`)
    const post = await r.json()
    r = await fetch(`/api/blog/${post.id}/comment`)
    const comments = (await r.json()).items
    return { post, comments }
}